import { Component, OnInit, ViewChild, ViewChildren, QueryList, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HasPermissions, Permissions } from '../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../core/services/permissions/permissions.service';
import { ProjectStep, ProjectType, ProjectStepWorklog, ProjectStepIssue, Project } from '../projects.model';
import { DateInputModel } from '../../core/shared/date-input/date-input.model';
import { SelectionMode, GoupedColumn, GroupFunction } from '../../core/shared/grid/grid.model';
import { CustomersListComponent } from '../../company/customers/customers-list/customers-list.component';
import { CustomersRest } from '../../company/customers/customers.rest';
import { CustomerRow } from '../../company/customers/customers.model';
import { ValidatorFn, AbstractControl, NgForm } from '@angular/forms';
import { ObjectToSelect } from '../../core/shared/objectToSelect.model';
import { ProjectsRest } from '../projects.rest';
import { MenuButton } from '../../core/shared/tabmenu/tabmenu.model';
import { RichTextComponent } from '../../core/shared/richtext/richtext.component';
import { MatTabChangeEvent } from '@angular/material';
import { GridComponent } from '../../core/shared/grid/grid.component';
import { SpinnerService } from '../../core/services/spinner-handler/spinner-handler.service';
import { ProjectService } from '../projects.service';
import { GridParamsRestoringService } from '../../core/services/grid-params-restoring/grid-params-restoring.service';
import { DialogService } from '../../core/shared/dialog/dialog.service';
import { DialogConfig } from '../../core/shared/dialog/dialog-config';

@Component({
  selector: 'app-projectstep',
  templateUrl: './projectstep.component.html',
  styleUrls: ['./projectstep.component.scss']
})
export class ProjectStepComponent implements OnInit, HasPermissions {

  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  private projectStep: ProjectStep;
  private maxValue = 9999999999999;
  private startDate: DateInputModel;
  private endDate: DateInputModel;
  private descriptionView: RichTextComponent = null;
  private states: ObjectToSelect[];
  private customerVstsEpics: ObjectToSelect[];
  private areaPaths: ObjectToSelect[];
  private projectType: ProjectType;
  private project: Project;
  private worklogs: ProjectStepWorklog[];
  private issues: ProjectStepIssue[];
  private oldCustomer: string;
  private oldReceiver: string;
  private enabled: boolean;
  private isSaving = false;
  private menuButtons: MenuButton[] = [
    { text: 'COMMONBUTTONS_save', class: "btn-success", icon: '', onClick: () => { this.saveProjectStep(); }, enabled: false, isForSelected: false },
    { text: 'COMMONBUTTONS_close', class: "btn-danger", icon: '', onClick: () => { this.close(); }, enabled: true, isForSelected: false }
  ];
  private saveButton = { text: 'COMMONBUTTONS_save', class: "btn-success", icon: '', onClick: () => { this.saveProjectStep(); }, enabled: false, isForSelected: false };

  @ViewChild('projectStepForm') projectStepForm: NgForm;
  @ViewChild(GridComponent) issuesGrid: GridComponent;
  @ViewChild(GridComponent) worklogsGrid: GridComponent;
  @ViewChildren(RichTextComponent) projectStepDescriptionViews: QueryList<RichTextComponent>;

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (!this.projectStepForm.valid) {
      return;
    }
    this.saveProjectStep();
    event.preventDefault();
  }

  private issueHeaders = [
    { displayName: 'Tytuł', propertyName: 'name', propertyType: 'string' },
    { displayName: 'Data zgłoszenia', propertyName: 'startDate', propertyType: 'date', isInitSort: true },
    { displayName: 'Czas pracy', propertyName: 'timeSpent', propertyType: 'number' },
    { displayName: 'Czas fakturowany', propertyName: 'invoiceTime', propertyType: 'number' },
    { displayName: 'Osoba odpowiedzialna', propertyName: 'assigneeName', propertyType: 'string' },
    { displayName: 'Realizujący', propertyName: 'elementAssignee', propertyType: 'string' },
    { displayName: 'Status', propertyName: 'objectStateName', propertyType: 'string' }
  ];

  private worklogHeaders = [
    { displayName: 'Tytuł zgłoszenia', propertyName: 'issueName', propertyType: 'string' },
    { displayName: 'Numer', propertyName: 'number', propertyType: 'string' },
    { displayName: 'Pracownik', propertyName: 'employee', propertyType: 'string' },
    { displayName: 'Data pracy', propertyName: 'workDate', propertyType: 'date', isInitSort: true },
    { displayName: 'Czas pracy', propertyName: 'timeSpent', propertyType: 'number' },
    { displayName: 'Czas fakturowany', propertyName: 'invoiceTime', propertyType: 'number' },
    { displayName: 'Opis', propertyName: 'description', propertyType: 'string' }
  ];


  constructor(private router: Router,
    private route: ActivatedRoute,
    private permissionService: PermissionsService,
    public dialog: DialogService,
    private customerRest: CustomersRest,
    private projectsRest: ProjectsRest,
    private spinnerService: SpinnerService,
    private projectService: ProjectService,
    private gridParamsRestoringService: GridParamsRestoringService) { }

  ngOnInit() {
    this.setPermissions("ProjectStep");
    this.projectsRest.getProjectStepStates().subscribe((data: ObjectToSelect[]) => {
      this.states = data;
    });
    this.getAreaPaths();
    this.projectService.currentProject.subscribe((project: Project) => {
      this.project = project;
      if (this.project) {
        this.route.queryParams.subscribe(params => {
          let id: any;
          id = parseInt(params.id);
          let projectType = parseInt(params.projectType) as ProjectType;
          this.projectType = projectType;
          if (this.project.isNew && this.project.newProjectSteps && id !== 0) {
            this.projectStep = this.project.newProjectSteps.find(x => x.id === id);
            this.enabled = this.permissions.canEdit;
            this.initializeDates();
            this.menuButtons.find(x => x.text === 'COMMONBUTTONS_save').enabled = this.enabled;
            this.saveButton.enabled = this.enabled;
          }
          else {
            this.projectsRest.getProjectStep(id, this.project.id, this.project.customerId).subscribe((result: ProjectStep) => {
              this.projectStep = result;
              this.enabled = this.permissions.canEdit;
              this.initializeDates();
              this.menuButtons.find(x => x.text === 'COMMONBUTTONS_save').enabled = this.enabled;
              this.saveButton.enabled = this.enabled;
            });
          }
        });
      } else {
        this.router.navigate(['../../../../'], { relativeTo: this.route });
      }
    }).unsubscribe();
  }

  private initializeDates() {
    this.startDate = new DateInputModel();
    this.startDate.isReadOnly = !this.enabled;
    this.startDate.isRequired = true;
    this.startDate.name = 'Od:';
    this.startDate.value = new Date(this.projectStep.startDate);
    this.startDate.valueStr = this.startDate.value.toDateString();
    this.startDate.withTime = false;

    this.endDate = new DateInputModel();
    this.endDate.isReadOnly = true;
    this.endDate.isRequired = false;
    this.endDate.name = 'Do:';

    if (this.projectStep.endDate) {

      this.endDate.value = new Date(this.projectStep.endDate);
      this.endDate.valueStr = this.endDate.value.toDateString();
      this.endDate.withTime = false;
      this.endDate.isReadOnly = !this.enabled;
    }
  }
  public onStartDateChange(element, isValid: boolean) {
    if (!element || !isValid) {
      return;
    }

    this.projectStep.startDate = this.startDate.value;
    this.startDate.valueStr = this.startDate.value.toDateString();
    if (this.projectStep.endDate !== null && this.startDate.value > this.endDate.value) {
      this.projectStep.endDate = this.projectStep.startDate;
      this.endDate.value = this.startDate.value;
      this.endDate.valueStr = this.startDate.valueStr;
    }
  }

  public onEndDateChange(element, isValid: boolean) {
    if (!element || !isValid) {
      return;
    }

    this.projectStep.endDate = this.endDate.value;
    this.endDate.valueStr = this.endDate.value.toDateString();
    if (this.startDate.value > this.endDate.value) {
      this.projectStep.startDate = this.projectStep.endDate;
      this.startDate.value = this.endDate.value;
      this.startDate.valueStr = this.endDate.valueStr;
    }
  }

  public openCustomerModal(customerName: string) {
    let dialogConf = new DialogConfig();
    dialogConf.selectionMode = SelectionMode.single;
    dialogConf.title = 'Wybierz kontrahenta';
    dialogConf.maxwidth = '1200px';
    dialogConf.data = { selectList: true };
    if (customerName) {
      dialogConf.data.initialFilters = { code: customerName };
    }

    const ref = this.dialog.open(CustomersListComponent, dialogConf);

    ref.afterClosed.subscribe((result: CustomerRow) => {
      if (result) {
        this.projectStep.customerId = result.id;
        this.projectStep.customerName = result.name;
        this.projectStep.payerId = result.id;
        this.projectStep.payerName = result.name;
        this.getCustomerVstsEpics();
      }
    });
  }

  public openReceiverModal(customerName: string) {
    let dialogConf = new DialogConfig();
    dialogConf.selectionMode = SelectionMode.single;
    dialogConf.title = 'Wybierz płatnika';
    dialogConf.maxwidth = '1200px';
    dialogConf.data = { selectList: true };
    if (customerName) {
      dialogConf.data.initialFilters = { code: customerName };
    }
    const ref = this.dialog.open(CustomersListComponent, dialogConf);
    ref.afterClosed.subscribe((result: CustomerRow) => {
      if (result) {
        this.projectStep.payerId = result.id;
        this.projectStep.payerName = result.name;
      }
    });
  }

  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    if (tabChangeEvent.index === 1) {
    }
    else if (tabChangeEvent.index === 2) {
      this.getDescription();
      this.projectStepDescriptionViews.notifyOnChanges();
    }
    else if (tabChangeEvent.index === 3) {
      if (this.issues === undefined || this.issues === null) {
        this.spinnerService.show();
        this.projectsRest.getRelatedProjectStepIssues(this.projectStep.id).subscribe((result: ProjectStepIssue[]) => {
          this.issues = result;
          this.spinnerService.hide();
        });
      }
    }
    else if (tabChangeEvent.index === 4) {
      if (this.worklogs === undefined || this.worklogs === null) {
        this.spinnerService.show();
        this.projectsRest.getRelatedProjectStepWorklogs(this.projectStep.id).subscribe((result: ProjectStepWorklog[]) => {
          this.worklogs = result;
          this.spinnerService.hide();
        });
      }
    }
    this.saveDescription();
  }

  private getDescription() {
    this.projectStepDescriptionViews.changes.subscribe((nv: QueryList<RichTextComponent>) => {
      if (this.descriptionView == null) {
        this.descriptionView = nv.first;
      }
      if (this.projectStep.id !== 0 || this.projectStep.description) {
        this.descriptionView.setHtml(this.projectStep.description);
        if (!this.enabled)
          this.descriptionView.disableContol();
      } else {
        this.descriptionView.setHtml('');
        if (!this.enabled)
          this.descriptionView.disableContol();
      }
    });
  }

  public saveDescription() {
    if (this.descriptionView == null) {
      return;
    }
    this.projectStep.description = this.descriptionView.getHtml();
  }

  public onKeyCustomer(event: any) {
    if (this.oldCustomer !== this.project.customerName) {
      this.projectStep.customerId = null;
      this.projectStep.payerId = null;
    }
    if (event.key === 'Enter') {
      this.searchCustomer();
    }
  }

  onKeyDownCustomer() {
    this.oldCustomer = this.project.customerName;
  }

  public onKeyReceiver(event: any) {
    if (this.oldReceiver !== this.project.customerName) {
      this.projectStep.payerId = null;
    }
    if (event.key === 'Enter') {
      this.searchReceiver();
    }
  }

  onKeyDownReceiver() {
    this.oldReceiver = this.project.receiverName;
  }

  private validateIds(controlValue: number): ValidatorFn {
    let isNull = false
    if (controlValue === null) {
      isNull = true;
    }
    return (control: AbstractControl): { [key: string]: any } | null => {
      return isNull ? { 'otherNotNull': { value: true } } : null;
    };
  }

  private searchCustomer() {
    if (!this.projectStep.customerName)
      return;
    this.customerRest.getCustomerRowsByName(this.projectStep.customerName).subscribe((result: CustomerRow[]) => {
      if (result.length == 1) {
        let customer = result[0];
        this.projectStep.customerId = customer.id;
        this.projectStep.customerName = customer.name;
        this.projectStep.payerId = customer.id;
        this.projectStep.payerName = customer.name;
        this.getCustomerVstsEpics();
      }
      else {
        this.openCustomerModal(this.projectStep.customerName);
      }
    });
  }

  private searchReceiver() {
    if (!this.projectStep.payerName)
      return;
    this.customerRest.getCustomerRowsByName(this.projectStep.payerName).subscribe((result: CustomerRow[]) => {
      if (result.length == 1) {
        let customer = result[0];
        this.projectStep.payerId = customer.id;
        this.projectStep.payerName = customer.name;
      }
      else {
        this.openReceiverModal(this.projectStep.payerName);
      }
    });
  }

  private getCustomerVstsEpics() {
    this.projectsRest.getCustomerVstsEpics(this.projectStep.customerId).subscribe((result: ObjectToSelect[]) => {
      this.customerVstsEpics = result;
    });
  }

  private getAreaPaths() {
    this.projectsRest.getAreaPaths().subscribe((areaPaths: ObjectToSelect[]) => {
      this.areaPaths = areaPaths;
    });
  }

  private checkSaveCondition() {
    return true;
  }

  public isInvalid() {
    if (this.checkSaveCondition()) {
      return this.projectStepForm.invalid;
    }
    return false;
  }

  private saveProjectStep() {
    if (this.isInvalid()) {
      sweetAlert('Dane są niekompletne, nie można zapisać');
      return;
    }

    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    if (this.project.isNew) {
      if (!this.project.newProjectSteps)
        this.project.newProjectSteps = new Array<ProjectStep>();
      if (!this.project.newProjectSteps.find(x => x.id === this.projectStep.id)) {
        this.projectStep.id = (this.project.newProjectSteps.length !== 0 ? Math.min.apply(Math, this.project.newProjectSteps.map(function (o) { return o.id; })) : 0) - 1;
        this.project.newProjectSteps.push(this.projectStep);
        this.gridParamsRestoringService.saveAddingNewRowInfo(this.projectStep.id, undefined, true);
      }
      this.projectService.passProject(this.project);
      this.isSaving = false;
      this.close();
    }
    else {
      this.projectsRest.saveProjectStep(this.projectStep).subscribe(result => {
        if (result) {
          if (this.projectStep.id === 0) {
            this.gridParamsRestoringService.saveAddingNewRowInfo(result, undefined, true);
          }
          this.projectService.passProject(this.project);
          this.isSaving = false;
          this.close();
        }
      });
    }
  }

  private close() {
    this.router.navigate(['../../'], { queryParams: { id: this.project.id, projectType: this.projectType }, relativeTo: this.route });

  }

  private onStatusChange(event) {
    this.projectStep.objectStateName = event[0].text;
  }

  private onBudgetChange(event) {
    this.projectStep.budget = event;
  }

  private onHourlyRateChange(event) {
    this.projectStep.timeBudget = event;
  }

  private columnsToGroup: GoupedColumn[] = [
    { name: 'timeSpent', func: GroupFunction.sum },
    { name: 'invoiceTime', func: GroupFunction.sum }
  ];
}
